import _objectWithoutProperties from "/opt/build/repo/node_modules/mdx.macro/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "h2",
    components: components
  }, "Bio"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "blockquote",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components,
    parentName: "blockquote"
  }, "Articulo en edici\xF3n")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Naci\xF3 el d\xEDa de San Pedro y San Pablo (29 de junio) de 1926 en Santa Clara, Cuba con el nombre de Pedro Mart\xEDn Perez. Fue el menor de tres hermanos, Juan y Fidel."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Muri\xF3 en Valencia, Venezuela por causas naturales, el 18 de enero de 2021 a los 94 a\xF1os."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Sus padres Bernab\xE9 Mart\xEDn Yanes y Toribia Perez Perez emigraron desde las islas Canarias. All\xED se radicaron un tiempo hasta que en 1939 emigraron a Venezuela a bordo del ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "https://en.wikipedia.org/wiki/German_submarine_U-1195#Service_history"
    }
  }, "SS Cuba"), "."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "En Venezuela, su famila se radic\xF3 en ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "https://es.wikipedia.org/wiki/Chirgua"
    }
  }, "Chirgua"), ", estado Carabobo y de all\xED se mudaron a Caracas."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Inici\xF3 su carrera art\xEDstica como actor en 1945, a los 19 a\xF1os de edad."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Trabajo en ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "https://es.wikipedia.org/wiki/Televisa_(Venezuela)"
    }
  }, "Televisa"), " (antesesor de Venevisi\xF3n) desde 1953 a 1961 y luego en RCTV"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Le sobreviven sus dos hijos, Yoana y Pedro; cuatro nietos, Miguel, Alejandra, Peter y Miranda; 3 bisnietos, Leticia, Noah, Matias."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "h2",
    components: components
  }, "Filmograf\xEDa"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "ul",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1953"), " Surcando los mares (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1953"), " La criada de la granja (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1961"), " Cinco destinos (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1964"), " Historia de hermanas (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1975"), " La Viuda (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1977"), " Se llamaba SN (Film)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1977"), " Se llamaba SN (Film)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1977"), " Todos los d\xEDas son s\xE1bados (Film)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1985"), " Las Amazones (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1988"), " Se\xF1ora (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1989"), " El enga\xF1o (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1990"), " Gardenia (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1993"), " Dulce ilusi\xF3n (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1995"), " El Desafio (TV serie)"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "li"
  }, "1996"), " El perd\xF3n de los pecados (TV serie)")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "h2",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "h2",
    props: {
      "href": "/gallery"
    }
  }, "Galer\xEDa de fotos")));
});